import * as userAction from "../actions/hestiaSRP.action";
const user = (
  state = {
    status: null,
    loading: false,
    error: null,
    hestiaSRPData: null,
    hestialoading: false,
  },
  action,
) => {
  switch (action.type) {
    case userAction.HESTIA_SRP_REQUEST:
      return Object.assign({}, state, {
        status: action.status,
        loading: true,
        hestialoading: true,
      });
    case userAction.HESTIA_SRP_SUCCESS:
      return Object.assign({}, state, {
        hestiaSRPData: action.hestiaSRPData,
        status: action.status,
        loading: false,
        hestialoading: false,
      });
    case userAction.HESTIA_SRP_FAILURE:
      return Object.assign({}, state, {
        error: action.error,
      });
    default:
      return state;
  }
};
export default user;
